import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Spin } from 'antd';

import config from '../../../config';

import './DrinkCustomization.less';
import DrinkOptionsSelector from './DrinkOptionsSelector';

const DrinkCustomization = forwardRef(({ selectedDrink: drink, onContinue, loading, customizations: drinkChoices }, ref) => {
	const [customizations, setCustomizations] = useState({});
	const drinkCustomizationRef = useRef(null);
	const requiredCustomizationIds = drinkChoices.filter(choice => choice.is_required === true).map(item => item._id);

	const preselectedOption = drink?.chosen_drink_customizations ? drink?.chosen_drink_customizations.map(item => item) : [];
	const preselectedOptionIds = preselectedOption.map(option => option.selected_options._id);

	useEffect(() => {
		if (!preselectedOption.length) return;
		preselectedOption.forEach(item => {
			setCustomizations(state => ({ ...state, [item.customization_id]: { ...item.selected_options } }));
		});
	}, []);

	// check if all of the required is are in customizations or not
	const isDisabled = () => {
		let required = false;

		if (preselectedOptionIds.length) return false;

		requiredCustomizationIds.forEach(id => {
			if (!customizations[id]) {
				required = true;
				return;
			}
		});

		return required;
	};

	const [disabled, setDisabled] = useState(isDisabled());

	const handleOptionOnClick = (customizationId, selectedOptions) => {
		const updated = { ...customizations, [customizationId]: selectedOptions };
		setCustomizations(updated);
		const allRequiredSelected = requiredCustomizationIds.every(id => updated[id]);
		setDisabled(!allRequiredSelected);
	};

	const handleContinue = () => {
		const keys = [...Object.keys(customizations)];
		const customizedItems = [];
		keys.forEach(key => {
			customizedItems.push({
				customization_id: key,
				selected_options: customizations[key]
			});
		});

		drink.chosen_drink_customizations = customizedItems;
		onContinue(drink);
	};

	useImperativeHandle(ref, () => ({
		getCustomizations: () => {
			const keys = [...Object.keys(customizations)];
			const customizedItems = [];
			keys.forEach(key => {
				customizedItems.push({
					customization_id: key,
					selected_options: customizations[key]
				});
			});

			return customizedItems;
		}
	}));

	if (loading) {
		return (
			<div className="drink-customization-selector">
				<div className="drink-customization-loading">
					<Spin size="large" />
					<p>Loading available drink options...</p>
				</div>
			</div>
		);
	}

	if (drink) {
		let imageUrl = null;
		if (drink.asset && drink.asset.uuid && drink.asset.token) {
			imageUrl = `${config.api}/app/assets/id?uuid=${drink.asset.uuid}&token=${drink.asset.token}`;
		}


		return (
			<div className="drink-customization-selector">
				<div className="drink-customization-header">
					{
						imageUrl && (
							<img
								src={imageUrl}
								alt={drink.name}
								className="drink-customization-image"
								style={{ aspectRatio: '16/9', width: '100%', borderRadius: '8px', objectFit: 'cover' }}
							/>
						)
					}
					<div className="drink-customization-content">
						<div>
							<h2 className="drink-customization-title">{drink.drink_name}</h2>
							<p className="drink-customization-subtitle">Customize Your Drink</p>
						</div>
						<h2 className="drink-price">${drink.drink_price.toFixed(2)}</h2>
					</div>
				</div>

				<div className="drink-customization-list">
					<DrinkOptionsSelector
						options={drinkChoices}
						ref={drinkCustomizationRef}
						onClick={handleOptionOnClick}
						preselectedOptionIds={preselectedOptionIds}
					/>
				</div>

				<div className="drink-customization-footer">
					<button
						className="drink-customization-continue-btn"
						onClick={handleContinue}
						disabled={disabled} // disable when required option isnt selected
					>
						下一步 Continue
					</button>
				</div>

			</div>

		);
	}

});

export default DrinkCustomization;
